import { render, staticRenderFns } from "./ExportTemplateTabs.vue?vue&type=template&id=15160eba&scoped=true&lang=pug"
import script from "./ExportTemplateTabs.vue?vue&type=script&lang=js"
export * from "./ExportTemplateTabs.vue?vue&type=script&lang=js"
import style0 from "./ExportTemplateTabs.vue?vue&type=style&index=0&id=15160eba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15160eba",
  null
  
)

export default component.exports